export default __webpack_public_path__ + "static/media/Eric_Chestier_Hayez_s_Kiss_2.0_50_x_70_cm.dfa94453.jpg";